import { Link } from "react-router-dom";
import type { Actor } from "@/types/content";

export default function ActorCard({ actor }: { actor: Actor }) {
  return (
    <Link
      to={`/actor/${actor.id}`}
      className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-accent-300"
    >
      <div className="w-16 h-16 shrink-0 overflow-hidden rounded-full bg-background-200 ring-2 ring-background-100">
        <img
          src={actor.avatar}
          alt={`演员 ${actor.name}`}
          title={`${actor.name} 参演作品介绍`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0">
        <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-accent-600 transition-colors">
          {actor.name}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{actor.tags.join(" · ")}</p>
        <p className="mt-1.5 text-xs text-foreground-600">参演作品 {actor.works.length} 部</p>
      </div>
    </Link>
  );
}